import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { printdDate } from '../helper.js';
import View from './View';

class termsView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Terms View Error Message';
  _message = 'Terms View Success Message';

  _generateMarkup() {
    return `
                   <div class="row terms">
        <h1 class="heading__static">Terms & Conditions</h1>
        <p class="paragraph">
          These terms and conditions (“Terms”, “Agreement”) are an agreement
          between Pragya Enterprises (“Pragya Enterprises”, “us”, “we” or “our”)
          and you (“User”, “you” or “your”). This Agreement sets forth the
          general terms and conditions of your use of the pragya.enterprises
          website and any of its products or services (collectively, “Website”
          or “Services”).
        </p>

        <h2 class="heading__static heading__static--sub">
          Accounts and membership
        </h2>
        <p class="paragraph">
          If you create an account on the Website, you are responsible for
          maintaining the security of your account and you are fully responsible
          for all activities that occur under the account and any other actions
          taken in connection with it. We may, but have no obligation to,
          monitor and review new accounts before you may sign in and use our
          Services. Providing false contact information of any kind may result
          in the termination of your account. You must immediately notify us of
          any unauthorized uses of your account or any other breaches of
          security. We will not be liable for any acts or omissions by you,
          including any damages of any kind incurred as a result of such acts or
          omissions. We may suspend, disable, or delete your account (or any
          part thereof) if we determine that you have violated any provision of
          this Agreement or that your conduct or content would tend to damage
          our reputation and goodwill. If we delete your account for the
          foregoing reasons, you may not re-register for our Services. We may
          block your email address and Internet protocol address to prevent
          further registration.
        </p>
        <h2 class="heading__static heading__static--sub">User content</h2>
        <p class="paragraph">
          We do not own any data, information or material (“Content”) that you
          submit on the Website in the course of using the Service. You shall
          have sole responsibility for the accuracy, quality, integrity,
          legality, reliability, appropriateness, and intellectual property
          ownership or right to use of all submitted Content. We may monitor and
          review Content on the Website submitted or created using our Services
          by you. Unless specifically permitted by you, your use of the Website
          does not grant us the license to use, reproduce, adapt, modify,
          publish or distribute the Content created by you or stored in your
          user account for commercial, marketing or any similar purpose. But you
          grant us permission to access, copy, distribute, store, transmit,
          reformat, display and perform the Content of your user account solely
          as required for the purpose of providing the Services to you. Without
          limiting any of those representations or warranties, we have the
          right, though not the obligation, to, in our own sole discretion,
          refuse or remove any Content that, in our reasonable opinion, violates
          any of our policies or is in any way harmful or objectionable.
        </p>
        <h2 class="heading__static heading__static--sub">
          Billing and payments
        </h2>
        <p class="paragraph">
          You shall pay all fees or charges to your account in accordance with
          the fees, charges, and billing terms in effect at the time a fee or
          charge is due and payable. Where Services are offered on a free trial
          basis, payment may be required after the free trial period ends, and
          not when you enter your billing details (which may be required prior
          to the commencement of the free trial period). If auto-renewal is
          enabled for the Services you have subscribed for, you will be charged
          automatically in accordance with the term you selected. If, in our
          judgment, your purchase constitutes a high-risk transaction, we will
          require you to provide us with a copy of your valid government-issued
          photo identification, and possibly a copy of a recent bank statement
          for the credit or debit card used for the purchase. We reserve the
          right to change products and product pricing at any time. We also
          reserve the right to refuse any order you place with us. We may, in
          our sole discretion, limit or cancel quantities purchased per person,
          per household or per order. These restrictions may include orders
          placed by or under the same customer account, the same credit card,
          and/or orders that use the same billing and/or shipping address. In
          the event that we make a change to or cancel an order, we may attempt
          to notify you by contacting the e-mail and/or billing address/phone
          number provided at the time the order was made.
        </p>
        <h2 class="heading__static heading__static--sub">Software Policy</h2>
        <p class="paragraph">
          Software is not a part of our agreement as software comes with many
          legal terms conditions & Regulations and it requires mandate License
          in order to use any professional software otherwise it comes under
          criminal act and it has huge penalties which you acknowledge prior to
          purchasing any product on the Website. Hence, we are not authorized to
          provide any software related support neither sale nor Services as we
          are not at all associated with any software companies directly or
          indirectly on our Portal as we are only dealing with only Courses.
        </p>
        <h2 class="heading__static heading__static--sub">Support Policy</h2>
        <p class="paragraph">
          As support is a critical aspect for any company so we want it to make
          really effective, precise & Hassle-free. So in order to maintain the
          best relationship between pragya.enterprises & its user which you
          acknowledge prior to purchasing any product on the website. You can
          contact our support team at any point of time as per the availability
          of our executives they will get back to you within maximum response
          time i.e. 8 to 24 hours.
        </p>

        <p class="paragraph">
          If you use any type of abusive language during support, we have right
          to immediately block your pragya.enterprises account and permanently
          delete your information and there is no refund in this case.
        </p>
        <h2 class="heading__static heading__static--sub">
          Accuracy of information
        </h2>
        <p class="paragraph">
          Occasionally there may be information on the Website that contains
          typographical errors, inaccuracies or omissions that may relate to
          promotions and offers. We reserve the right to correct any errors,
          inaccuracies or omissions, and to change or update information or
          cancel orders if any information on the Website or on any related
          Service is inaccurate at any time without prior notice (including
          after you have submitted your order). We undertake no obligation to
          update, amend or clarify information on the Website including, without
          limitation, pricing information, except as required by law. No
          specified update or refresh date applied on the Website should be
          taken to indicate that all information on the Website or on any
          related Service has been modified or updated.
        </p>
        <h2 class="heading__static heading__static--sub">
          Automatic collection of information
        </h2>
        <p class="paragraph">
          When you visit the Website our servers automatically record
          information that your browser sends. This data may include information
          such as your device's IP address, browser type and version, operating
          system type and version, language preferences or the webpage you were
          visiting before you came to our Website, pages of our Website that you
          visit, the time spent on those pages, information you search for on
          our Website, access times and dates, and other statistics.
        </p>
        <h2 class="heading__static heading__static--sub">System abuse</h2>
        <p class="paragraph">
          Any User in violation of our Services security is subject to criminal
          and civil liability, as well as immediate account termination.
          Examples include, but are not limited to the following:
        </p>
        <!-- <p class="paragraph"> -->
        <ul style="padding-left: 3.2rem">
          <li class="paragraph">
            Use or distribution of tools designed for compromising security of
            the Services.
          </li>
          <li class="paragraph">
            Intentionally or negligently transmitting files containing a
            computer virus or corrupted data.
          </li>
          <li class="paragraph">
            Accessing another network without permission, including to probe or
            scan for vulnerabilities or breach security or authentication
            measures.
          </li>
          <li class="paragraph">
            Unauthorized scanning or monitoring of data on any network or system
            without proper authorization of the owner of the system or network.
          </li>
        </ul>
        <!-- </p> -->

        <h2 class="heading__static heading__static--sub">
          Third-party services
        </h2>
        <p class="paragraph">
          If you decide to enable, access or use third-party services, be
          advised that your access and use of such other services are governed
          solely by the terms and conditions of such other services, and we do
          not endorse, are not responsible or liable for, and make no
          representations as to any aspect of such other services, including,
          without limitation, their content or the manner in which they handle
          data (including your data) or any interaction between you and the
          provider of such other services. You irrevocably waive any claim
          against Pragya Enterprises with respect to such other services. Pragya
          Enterprises is not liable for any damage or loss caused or alleged to
          be caused by or in connection with your enablement, access or use of
          any such other services, or your reliance on the privacy practices,
          data security processes or other policies of such other services. You
          may be required to register for or log into such other services on
          their respective websites. By enabling any other services, you are
          expressly permitting Pragya Enterprises to disclose your data as
          necessary to facilitate the use or enablement of such other service.
        </p>
        <h2 class="heading__static heading__static--sub">Uptime guarantee</h2>
        <p class="paragraph">
          We offer a Service uptime guarantee of 99% of available time per
          month. The service uptime guarantee does not apply to service
          interruptions caused by: (1) periodic scheduled maintenance or repairs
          we may undertake from time to time; (2) interruptions caused by you or
          your activities; (3) outages that do not affect core Service
          functionality; (4) causes beyond our control or that are not
          reasonably foreseeable; and (5) outages related to the reliability of
          certain programming environments.
        </p>
        <h2 class="heading__static heading__static--sub">Backups</h2>
        <p class="paragraph">
          We perform regular backups of the Website and Content and will do our
          best to ensure completeness and accuracy of these backups. In the
          event of the hardware failure or data loss we will restore backups
          automatically to minimize the impact and downtime.
        </p>
        <h2 class="heading__static heading__static--sub">Advertisements</h2>
        <p class="paragraph">
          During use of the Website, you may enter into correspondence with or
          participate in promotions of advertisers or sponsors showing their
          goods or services through the Website. Any such activity, and any
          terms, conditions, warranties or representations associated with such
          activity, is solely between you and the applicable third-party. We
          shall have no liability, obligation or responsibility for any such
          correspondence, purchase or promotion between you and any such
          third-party.
        </p>
        <h2 class="heading__static heading__static--sub">
          Links to other websites
        </h2>
        <p class="paragraph">
          Although this Website may link to other websites, we are not, directly
          or indirectly, implying any approval, association, sponsorship,
          endorsement, or affiliation with any linked website, unless
          specifically stated herein. Some of the links on the Website may be
          “affiliate links”. This means if you click on the link and purchase an
          item, Pragya Enterprises will receive an affiliate commission. We are
          not responsible for examining or evaluating, and we do not warrant the
          offerings of, any businesses or individuals or the content of their
          websites. We do not assume any responsibility or liability for the
          actions, products, services, and content of any other third-parties.
          You should carefully review the legal statements and other conditions
          of use of any website which you access through a link from this
          Website. Your linking to any other off-site websites is at your own
          risk.
        </p>
        <h2 class="heading__static heading__static--sub">Prohibited uses</h2>
        <p class="paragraph">
          In addition to other terms as set forth in the Agreement, you are
          prohibited from using the Website or its Content: (a) for any unlawful
          purpose; (b) to solicit others to perform or participate in any
          unlawful acts; (c) to violate any international, federal, provincial
          or state regulations, rules, laws, or local ordinances; (d) to
          infringe upon or violate our intellectual property rights or the
          intellectual property rights of others; (e) to harass, abuse, insult,
          harm, defame, slander, disparage, intimidate, or discriminate based on
          gender, sexual orientation, religion, ethnicity, race, age, national
          origin, or disability; (f) to submit false or misleading information;
          (g) to upload or transmit viruses or any other type of malicious code
          that will or may be used in any way that will affect the functionality
          or operation of the Service or of any related website, other websites,
          or the Internet; (h) to collect or track the personal information of
          others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape;
          (j) for any obscene or immoral purpose; or (k) to interfere with or
          circumvent the security features of the Service or any related
          website, other websites, or the Internet. We reserve the right to
          terminate your use of the Service or any related website for violating
          any of the prohibited uses.
        </p>
        <h2 class="heading__static heading__static--sub">
          Intellectual property rights
        </h2>
        <p class="paragraph">
          This Agreement does not transfer to you any intellectual property
          owned by Pragya Enterprises or third-parties, and all rights, titles,
          and interests in and to such property will remain (as between the
          parties) solely with Pragya Enterprises. All trademarks, service
          marks, graphics and logos used in connection with our Website or
          Services, are trademarks or registered trademarks of Pragya
          Enterprises or Pragya Enterprises licensors. Other trademarks, service
          marks, graphics and logos used in connection with our Website or
          Services may be the trademarks of other third-parties. Your use of our
          Website and Services grants you no right or license to reproduce or
          otherwise use any Pragya Enterprises or third-party trademarks.
        </p>
        <h2 class="heading__static heading__static--sub">
          Disclaimer of warranty
        </h2>
        <p class="paragraph">
          You agree that your use of our Website or Services is solely at your
          own risk. You agree that such Service is provided on an “as is” and
          “as available” basis. We expressly disclaim all warranties of any
          kind, whether express or implied, including but not limited to the
          implied warranties of merchantability, fitness for a particular
          purpose and non-infringement. We make no warranty that the Services
          will meet your requirements, or that the Service will be
          uninterrupted, timely, secure, or error-free; nor do we make any
          warranty as to the results that may be obtained from the use of the
          Service or as to the accuracy or reliability of any information
          obtained through the Service or that defects in the Service will be
          corrected. You understand and agree that any material and/or data
          downloaded or otherwise obtained through the use of Service is done at
          your own discretion and risk and that you will be solely responsible
          for any damage to your computer system or loss of data that results
          from the download of such material and/or data. We make no warranty
          regarding any goods or services purchased or obtained through the
          Service or any transactions entered into through the Service. No
          advice or information, whether oral or written, obtained by you from
          us or through the Service shall create any warranty not expressly made
          herein.
        </p>
        <h2 class="heading__static heading__static--sub">Indemnificatio</h2>
        <p class="paragraph">
          You agree to indemnify and hold Pragya Enterprises and its affiliates,
          directors, officers, employees, and agents harmless from and against
          any liabilities, losses, damages or costs, including reasonable
          attorneys' fees, incurred in connection with or arising from any
          third-party allegations, claims, actions, disputes, or demands
          asserted against any of them as a result of or relating to your
          Content, your use of the Website or Services or any willful misconduct
          on your part.
        </p>
        <h2 class="heading__static heading__static--sub">Dispute resolution</h2>
        <p class="paragraph">
          The formation, interpretation, and performance of this Agreement and
          any disputes arising out of it shall be governed by the substantive
          and procedural laws of West Bengal, India without regard to its rules
          on conflicts or choice of law and, to the extent applicable, the laws
          of India. The exclusive jurisdiction and venue for actions related to
          the subject matter hereof shall be the state and federal courts
          located in West Bengal, India, and you hereby submit to the personal
          jurisdiction of such courts. You hereby waive any right to a jury
          trial in any proceeding arising out of or related to this Agreement.
          The United Nations Convention on Contracts for the International Sale
          of Goods does not apply to this Agreement.
        </p>
        <h2 class="heading__static heading__static--sub">Assignment</h2>
        <p class="paragraph">
          You may not assign, resell, sub-license or otherwise transfer or
          delegate any of your rights or obligations hereunder, in whole or in
          part, without our prior written consent, which consent shall be at our
          own sole discretion and without obligation; any such assignment or
          transfer shall be null and void. We are free to assign any of its
          rights or obligations hereunder, in whole or in part, to any
          third-party as part of the sale of all or substantially all of its
          assets or stock or as part of a merger.
        </p>
        <h2 class="heading__static heading__static--sub">
          Changes and amendments
        </h2>
        <p class="paragraph">
          We reserve the right to modify this Agreement or its policies relating
          to the Website or Services at any time, effective upon posting of an
          updated version of this Agreement on the Website. When we do, we will
          revise the updated date at the bottom of this page. Continued use of
          the Website after any such changes shall constitute your consent to
          such changes.
        </p>
        <h2 class="heading__static heading__static--sub">
          Acceptance of these terms
        </h2>
        <p class="paragraph">
          You acknowledge that you have read this Agreement/Policy and agree to
          all its terms and conditions. By using the Website or its Services you
          agree to be bound by this Agreement/Policy. If you do not agree to
          abide by the terms of this Agreement/Policy, you are not authorized to
          use or access the Website and its Services.
        </p>
        <h2 class="heading__static heading__static--sub">Refund Policy</h2>
        <p class="paragraph">
          We do not provide any sort of refunds after the product is been sold
          to customer, which you acknowledge prior to purchasing any product on
          the Website. Please make sure that you've carefully read service
          description before making a purchase. Once any sort of payments is
          been made for any product is non-Refundable.
        </p>
        <h2 class="heading__static heading__static--sub">Contacting us</h2>
        <p class="paragraph">
          If you would like to contact us to understand more about this
          Agreement or wish to contact us concerning any matter relating to it,
          you may do so via sending an email to pragya231006@gmail.com
        </p>

        <p class="paragraph">This document was last updated on May 11, 2026</p>
      </div>
    `;
  }
}

export default new termsView();
